import { Event } from '@/interfaces/event';
import { EntityResource } from './entity.resource';
import { TypeFilterVariables } from './queryVariables/filters/filters';

/**
 * Resource etapów
 *
 * @export
 * @class StatusResource
 * @extends {EntityResource<Event>}
 */
export class EventResource extends EntityResource<Event> {
  public getFields = {
    id: true,
    name: true,
    type: true,
    action: true,
    actionData: true
  };

  public listFields = {
    id: true,
    name: true,
    type: true,
    action: true
  };

  protected listVariables = TypeFilterVariables;

  constructor() {
    super({
      entityName: 'event'
    });
  }
}

export const eventResource = new EventResource();
